import axios from 'axios';
import router from '../router';

const state = {
// users state
  customers: []
};

const mutations = {
// users mutations
    SET_CUSTOMERS(state, customers) {
        state.customers = customers;
    },
};

const actions = {
  async fetchCustomers({ commit }, { search }) {
    const userToken = localStorage.getItem('userToken');
    if (!userToken) {
        throw new Error('No token found'); // Handle absence of token
    }
    
    try {
        const baseUrl = process.env.VUE_APP_API_BASE_URL || 'http://localhost:3000/api';
        const response = await axios.get(`${baseUrl}/customers`, {
            headers: { Authorization: `Bearer ${userToken}` },
            params: { search } // Include search parameter in request
        });
        commit('SET_CUSTOMERS', response.data); // Update Vuex store with users
    } catch (error) {
        console.error('Error fetching customers:', error); // Log any errors
        throw error; // Handle error in your components
    }
  },
  async getCustomerByID({ commit }, customerId) { // Change from destructuring to direct variable
    console.log('Fetching customer with ID:', customerId);
    const userToken = localStorage.getItem('userToken'); 
    if (!userToken) {
        router.push({ name: 'login' });
        return;
    }

    try {
        const baseUrl = process.env.VUE_APP_API_BASE_URL || 'http://localhost:3000/api';
        const response = await axios.get(`${baseUrl}/customers/${customerId}`, {
            headers: { Authorization: `Bearer ${userToken}` }
        });
        console.log('Supplier fetch response:', response.data);
        commit('SET_CUSTOMERS', response.data);
    } catch (error) {
        console.error('Error fetching customer:', error);
        throw error;
    }
  },
  async createCustomer({ dispatch }, { customer }) {
    const userToken = localStorage.getItem('userToken');
    if (!userToken) {
      router.push({ name: 'login' });
      return;
    }
  
    try {
      const baseUrl = process.env.VUE_APP_API_BASE_URL || 'http://localhost:3000/api';
      await axios.post(`${baseUrl}/customers`, customer, {
        headers: { Authorization: `Bearer ${userToken}` }
      });
      console.log('Customer created:', customer);
      dispatch('fetchcustomers', { search: '' });
    } catch (error) {
      console.error('Error creating supplier:', supplier);
      throw error; // rethrow for component to handle
    }
  },
  async updateCustomer({ dispatch }, { customer }) {
    console.log('Updating customer:', customer);
    const userToken = localStorage.getItem('userToken');
    if (!userToken) {
      router.push({ name: 'login' });
      return;
    }
  
    try {
      const baseUrl = process.env.VUE_APP_API_BASE_URL || 'http://localhost:3000/api';
        await axios.put(`${baseUrl}/customers/${customer.id}`, customer,
          { headers: { Authorization: `Bearer ${userToken}` } }
        );
        console.log('Customer updated:', customer);
        dispatch('fetchCustomer', { search: '' });
      } catch (error) {
        console.error('Error updating customer:', customer);
        throw error;
      }
  },
  async deleteCustomer({ dispatch }, { customer }) {
    console.log('Deleting customer:', customer);
    const userToken = localStorage.getItem('userToken');
    console.log('User token:', userToken);
    if (!userToken) {
      router.push({ name: 'login' });
      return;
    }
  
    try {
      const baseUrl = process.env.VUE_APP_API_BASE_URL || 'http://localhost:3000/api';
      await axios.delete(`${baseUrl}/customers/${customer}`,
        { headers: { Authorization: `Bearer ${userToken}` } }
      );
      console.log('Customer deleted:', customer);
      dispatch('fetchCustomer', { search: '' });
    } catch (error) {
      console.error('Error deleting location:', error);
      throw error;
    }
  }  
};

const getters = {
// users getters
};
    
export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
};